import {Injectable} from '@angular/core';
import {HttpErrorResponse} from '@angular/common/http';
import {throwError} from 'rxjs';

@Injectable({providedIn: 'root'})
export class ExceptionHandlingService {

  handle(error: HttpErrorResponse) {
    let message: string;

    switch (error.status) {
      case 0:
        message = 'Network error. Please check your internet.';
        break;

      case 400:
        message = error.error?.message || 'Bad request';
        break;

      case 401:
        message = 'Unauthorized. Please login again.';
        break;

      case 403:
        message = 'You do not have permission to perform this action.';
        break;

      case 404:
        message = 'Requested resource not found.';
        break;

      case 422:
        message = 'Requested validation failed.';
        break;

      case 500:
        message = 'Server error. Please try later.';
        break;

      default:
        message = error.error?.message || 'Unexpected error occurred.';
    }

    // 🔔 USER VISIBLE ALERT
    console.log(message);

    return throwError(() => error);
  }
}
